import Vue from 'vue';
import Vuex from 'vuex';
import type { CustomilyUser } from '@/typings/user';
import type { UserFont } from '@/composables/fonts';
import type { Subscription } from '@/api/typings/billing';
import storeLayersModal, { LayersImportState } from '@/components/Layers/modal/store/layers-modal';
import storeLayers from '@/components/Layers/tree/store';
import { LayersTreeState } from '@/components/Layers/tree/store/types';
import {
    store as imageEffectsPropertiesStore,
    ImageEffectsPropertiesState
} from '@/components/DesignStudio/ImageEffectsProperties/store';

export interface LoaderState {
    active: boolean;
    text?: string;
}

interface State {
    user: CustomilyUser | undefined | null;
    stripePublicKey: string;
    subscriptions: Subscription[];
    selectedSubscription: Subscription | null;
    userFonts: UserFont[];
    storeLayersModal?: LayersImportState;
    storeLayers?: LayersTreeState;
    imageEffectsProperties?: ImageEffectsPropertiesState;
    loader: LoaderState;
}

Vue.use(Vuex);

const subscriptions: Subscription[] = [];
const defaultState: State = {
    user: null,
    subscriptions,
    selectedSubscription: subscriptions.filter((s) => s.Status !== 'active' && s.Status !== 'trialing')[0],
    userFonts: [],
    loader: {
        active: false
    },
    stripePublicKey: process.env.VUE_APP_STRIPE_PUBLIC_KEY
};

const store = new Vuex.Store({
    state: defaultState,
    mutations: {
        user: (state, user: CustomilyUser | undefined | null) => {
            state.user = user;
        },
        subscriptions: (state, subscriptions: Subscription[]) => {
            state.subscriptions = subscriptions;
        },
        loader: (state, loader: LoaderState) => {
            state.loader = { ...loader };
        },
        userFonts: (state, fonts: UserFont[]) => {
            state.userFonts = [...fonts];
        },
        setSelectedSusbcription: (state, subscription: Subscription) => {
            state.selectedSubscription = subscription;
        }
    },
    actions: {},
    modules: {
        storeLayersModal,
        storeLayers,
        imageEffectsProperties: imageEffectsPropertiesStore
    }
});

export default store;
